export default "__VITE_ASSET__RNQKUuxB__"